import React from 'react';
import { Link } from 'gatsby';

import Wrapper from '../elements/wrapper';

import FooterStyles from './footer-styles';

import Wave from '../../images/waves/footer-wave.inline.svg';
import { FaFacebookSquare, FaTwitterSquare, FaInstagram } from 'react-icons/fa';

import Logo from '../../images/logo.inline.svg';

const footerLinks = [
    {
        title: 'Shop',
        url: '#',
    },
    {
        title: 'Featured',
        url: '/pages/featured',
    },
    {
        title: 'Impact',
        url: '/pages/fighting-climate-change',
    },
    {
        title: 'Branded',
        url: '/pages/branded-category',
    },
    {
        title: 'Weddings',
        url: '/pages/weddings',
    },
    {
        title: 'Contact Us',
        url: '/pages/contact-us',
    },
    {
        title: 'FAQ',
        url: '#',
    },
    {
        title: 'Returns & Exchanges',
        url: '#',
    },
    {
        title: 'My Account',
        url: '#',
    },
];

const Footer = () => {
    return (
        <FooterStyles>
            <div className="svg-container">
                <Wave />
            </div>
            <Wrapper className="top-footer-wrapper">
                <div className="left-container">
                    <div className="mobile-footer-logo-container">
                        <Logo />
                    </div>
                    <div className="footer-links-container">
                        <div className="desktop-footer-logo-container">
                            <Logo />
                        </div>
                        <div className="list-container">
                            <ul>
                                {footerLinks &&
                                    footerLinks
                                        .slice(0, 5)
                                        .map((link, index) => {
                                            return (
                                                <li key={index}>
                                                    <Link to={link.url}>
                                                        {link.title}
                                                    </Link>
                                                </li>
                                            );
                                        })}
                            </ul>
                        </div>
                        <div className="list-container">
                            <ul>
                                {footerLinks &&
                                    footerLinks
                                        .slice(5, footerLinks.length)
                                        .map((link, index) => {
                                            return (
                                                <li key={index}>
                                                    <Link to={link.url}>
                                                        {link.title}
                                                    </Link>
                                                </li>
                                            );
                                        })}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="right-container">
                    <div className="inner-wrap">
                        <div className="footer-form-container">
                            <h4>Sign Up For Offers and Special Updates</h4>
                            <form>
                                <div className="input-row">
                                    <div className="input-container">
                                        <input
                                            type="email"
                                            placeholder="your@emailhere.com"
                                        />
                                        <button>Sign Up</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="social-row">
                            <div className="social-container">
                                <h4>Connect With Us</h4>
                                <ul>
                                    <li>
                                        <a href="#">
                                            <FaFacebookSquare />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <FaTwitterSquare />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <FaInstagram />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="email-container">
                                <p>
                                    <a href="mailto:team@goodformdesign.com">
                                        team@goodformdesign.com
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Wrapper>
            <Wrapper className="copyright-container">
                <div className="text-container">
                    <p>© {new Date().getFullYear()}, Goodform Inc.</p>
                    <p>926 W 10th Ave. Denver, CO USA</p>
                </div>
                <div className="links-container">
                    <ul>
                        <li>
                            <Link to="#">Terms and Conditions</Link>
                        </li>
                        <li>
                            <Link to="#">Privacy Policy</Link>
                        </li>
                    </ul>
                </div>
            </Wrapper>
        </FooterStyles>
    );
};

export default Footer;
